<template>
    <sweet-modal
        icon="warning"
        ref="blockUserModal"
        @close="$emit('modal-close')"
    >
        <div v-if="selected !== null" class="text-center">
            <p
                class="mt-3"
                v-html="
                    $t('pages.admin.users.block_confirmation', {
                        first_name: selected.first_name,
                        last_name: selected.last_name
                    })
                "
            ></p>
            <block-confirmation  @clicked="blockUser">
                {{ $t("actions.block") }}
            </block-confirmation>
        </div>
    </sweet-modal>
</template>

<script>
import { SweetModal } from "sweet-modal-vue";
import AdminUsersRepository from "../../../repositories/Admin/AdminUsersRepository";
import BlockConfirmation from "../../Includes/BlockConfirmation";

export default {
    name: "UserBlockModal",
    components: { SweetModal, BlockConfirmation },
    props: {
        selected: {
            type: Object,
            default: null
        }
    },
    methods: {
        blockUser(user) {
            if (this.selected === null) {
                return false;
            }
            AdminUsersRepository.blockUser(this.selected.id).then(res => {
                this.$emit("user-blocked");
                this.$refs.blockUserModal.close();
            });
        }
    },
    watch: {
        selected: function(val) {
            if (val !== null) this.$refs.blockUserModal.open();
        }
    }
};
</script>

<style scoped></style>
